module.exports = __webpack_public_path__ + "img/pfb-35-26_750.prt.08c9c866.jpg";